import styled, { css } from 'styled-components';
import logo from 'assets/logo/logo.png';
import arrowIcon from 'assets/icons/arrow.png';
import bbumLogo from 'assets/logo/bbum_logo.png';
import { animation } from 'utils';
import { Icon } from 'AppStyles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.img.attrs(() => ({
  src: logo,
}))`
  position: relative;
  width: 370px;
  top: 46px;
  left: 60px;
  z-index: 1;
  @media (max-width: 560px) {
    width: 340px;
    top: 40px;
    left: 15px;
  }
  @media (max-width: 450px) {
    width: 300px;
  }
  @media (max-width: 400px) {
    width: 270px;
  }
`;

export const Content = styled.div`
  position: relative;
  border-radius: 30px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow: hidden;
  margin: 0 2rem;
`;

export const BackIcon = styled(Icon).attrs(() => ({
  src: arrowIcon,
}))`
  position: absolute;
  width: 30px;
  right: 20px;
  top: 15px;
  z-index: 1;
`;

export const TokenLogin = styled.div`
  display: flex;
  flex-direction: column;
  animation: ${animation.slideLeft} 0.8s forwards;
  text-align: center;
  padding: 1.5rem 2rem;
`;

export const Title = styled.h1`
  padding-bottom: 0.5rem;
  border-bottom: 3px solid #d8d8d8;
`;

export const SubTitle = styled.div`
  font-weight: 600;
`;

export const Form = styled.div`
  position: relative;
  @media (max-width: 450px) {
    width: 250px;
  }
`;

export const Input = styled.input`
  font-size: 1.2em;
  border: 1px solid gray;
  border-radius: 5px;
  height: 60px;
  width: 100%;
  padding: 0.75rem 1rem;
  outline-color: darkblue;
  &::placeholder {
    opacity: 0;
  }
  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: 0;
    color: darkblue;
    background: #fff;
    padding: 7px;
  }
`;

export const Label = styled.label`
  position: absolute;
  left: 25px;
  top: ${({ $isError }) => ($isError ? '35%' : '50%')};
  transform: translateY(-50%);
  letter-spacing: 1px;
  transition: 0.3s;
  font-weight: 600;
  color: #999;
`;

const buttonColors = {
  blue: { base: 'rgba(35, 95, 220, 0.9)', hover: 'rgba(65, 123, 248, 0.9)' },
  darkBlue: { base: 'rgba(49, 60, 136, 0.9)', hover: 'rgba(73, 88, 185, 0.9)' },
  green: { base: 'rgba(34, 221, 51, 0.9)', hover: 'rgba(45, 235, 61, 0.9)' },
};

export const Button = styled.button`
  ${({ color }) => css`
    background-color: ${buttonColors[color]?.base};
    &:hover {
      transition: 0.2s;
      background-color: ${buttonColors[color]?.hover};
    }
  `};
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 1.2em;
  font-weight: 600;
  font-family: inherit;
  padding: 1rem;
  color: #ffffff;
  border: unset;
  border-radius: 10px;
  cursor: pointer;
  gap: ${({ $isLoading }) => ($isLoading ? '0.5rem' : '1rem')};
  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const LoginButton = styled(Button)`
  position: relative;
  justify-content: center;
  width: 250px;
`;

export const WheresMyCode = styled.div`
  font-size: 1.3em;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  color: #000;
`;

export const MethodButtons = styled.div`
  ${({ $isAnimation }) =>
    $isAnimation &&
    css`
      animation: ${animation.slideRight} 0.8s forwards;
    `};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 6rem;
  gap: 1.5rem;
  @media (max-width: 560px) {
    padding: 3rem;
  }
  @media (max-width: 450px) {
    padding: 2.5rem;
  }
  @media (max-width: 360px) {
    padding: 2rem;
  }
`;

export const BBumLogo = styled.img.attrs(() => ({
  src: bbumLogo,
}))`
  margin: 2rem auto 0;
  width: 150px;
`;

export const SocialButtons = styled.div`
  display: flex;
  margin: 1.5rem 0;
  gap: 2rem;
`;

export const Link = styled.a.attrs(() => ({
  target: '_blank',
}))`
  color: #fff;
`;
